module.exports = __webpack_public_path__ + "img/check-on-disabled.65774fa0.svg";